export default {
  // Navigation
  nav_home: '홈',
  nav_dashboard: '대시보드',
  nav_orders: '주문',
  nav_wallet: '지갑',
  nav_analytics: '분석',
  nav_referral: '추천',
  nav_account: '계정',
  nav_notifications: '알림',
  nav_support: '지원',
  nav_logout: '로그아웃',
  nav_login: '로그인',
  nav_signup: '가입',

  // Dashboard
  dashboard_welcome: '환영합니다',
  dashboard_total_earnings: '총 수익',
  dashboard_pending_orders: '대기 중인 주문',
  dashboard_completed_orders: '완료된 주문',
  dashboard_commission_rate: '수수료율',
  dashboard_quick_actions: '빠른 작업',
  dashboard_recent_orders: '최근 주문',
  dashboard_recent_activity: '최근 활동',
  dashboard_wallet_balance: '지갑 잔액',
  dashboard_deposit: '입금',
  dashboard_withdraw: '출금',
  dashboard_view_all: '모두 보기',

  // Orders
  security_row_title: '보안 설정',
  security_login_pw: '로그인 비밀번호',
  security_login_pw_desc: '계정 로그인 비밀번호를 변경합니다',
  security_change_btn: '변경',
  security_set_withdrawal_pw_title: '출금 비밀번호 설정',
  security_set_withdrawal_pw_desc: '출금을 승인하기 위한 별도의 PIN을 생성합니다',
  security_set_withdrawal_pw_btn: 'PIN 설정',
  security_change_withdrawal_pw_title: '출금 비밀번호 변경',
  security_change_withdrawal_pw_desc: '기존 출금 PIN을 업데이트합니다',
  security_change_withdrawal_pw_btn: '변경',
  security_modal_set_withdrawal_title: '출금 비밀번호 설정',
  security_modal_set_withdrawal_subtitle: '이 PIN은 출금할 때마다 필요합니다.',
  security_modal_change_withdrawal_title: '출금 비밀번호 변경',
  security_field_current_pin: '현재 출금 PIN',
  security_field_new_pin: '새 출금 PIN',
  security_field_new_pin_6: '새 출금 PIN (6자리)',
  security_field_confirm_pin: 'PIN 확인',
  security_field_confirm_new_pin: '새 PIN 확인',
  security_placeholder_pin_dots: '......',
  security_pw_current: '현재 비밀번호',
  orders_title: '내 주문',
  orders_all: '모든 주문',
  orders_pending: '대기 중',
  orders_completed: '완료',
  orders_cancelled: '취소됨',
  orders_order_id: '주문 ID',
  orders_platform: '플랫폼',
  orders_amount: '금액',
  orders_commission: '수수료',
  orders_status: '상태',
  orders_date: '날짜',
  orders_no_orders: '주문을 찾을 수 없습니다',
  orders_step_1: '제품 상세 정보 검토',
  orders_step_2: '주문 정보 확인',
  orders_step_3: '플랫폼 연결 중',
  orders_step_4: '프로모션 제출',
  orders_step_5: 'SEO 인덱싱',
  orders_step_6: '가시성 향상',
  orders_step_7: '최종 완료 및 확인',
  orders_btn_optimize: '주문 최적화',
  orders_btn_claim_commission: '수수료 청구',
  orders_btn_task_completed: '작업 완료',
  orders_price_label: '주문 가격',
  orders_commission_rate_label: '수수료율',

  // Wallet
  wallet_title: '내 지갑',
  wallet_available_balance: '사용 가능한 잔액',
  wallet_pending_balance: '대기 중인 잔액',
  wallet_total_withdrawn: '총 출금액',
  wallet_deposit_now: '지금 입금',
  wallet_withdraw_now: '지금 출금',
  wallet_transaction_history: '거래 내역',
  wallet_deposit_history: "Deposit History",
  wallet_withdrawal_history: '출금 내역',
  wallet_deposit_desc: "사용 가능한 결제 방법으로 지갑에 돈을 추가하세요.",
  wallet_no_deposits: "입금 내역이 없습니다.",
  wallet_withdraw_history: "출금 내역",
  wallet_withdraw_desc: "지갑에서 돈을 출금하세요.",
  wallet_no_withdrawals: "출금 내역이 없습니다.",
  wallet_no_withdrawals_desc: "아직 인출을 하지 않았습니다.",
  withdrawal_restricted_title: '출금 제한',
  withdrawal_restricted_message: '현재 귀하의 계정으로 출금을 이용하실 수 없습니다. 자세한 내용은 고객지원으로 문의해 주시기 바랍니다.',

  // Analytics
  analytics_title: '분석',
  analytics_earnings_overview: '수익 개요',
  analytics_platform_breakdown: '플랫폼별 분석',
  analytics_performance_metrics: '성과 지표',
  analytics_top_products: '인기 제품',
  analytics_this_month: '이번 달',
  analytics_last_month: '지난 달',
  analytics_total_revenue: '총 수익',
  analytics_avg_order_value: '평균 주문 금액',

  // Referral
  referral_title: '추천 프로그램',
  referral_your_code: '내 추천 코드',
  referral_copy_code: '코드 복사',
  referral_share_link: '링크 공유',
  referral_total_referrals: '총 추천 수',
  referral_active_referrals: '활성 추천',
  referral_referral_earnings: '추천 수익',
  referral_invite_friends: '친구 초대',

  // Account
  account_title: '계정 설정',
  account_profile: '프로필',
  account_security: '보안',
  account_notifications: '알림',
  account_kyc: 'KYC 인증',
  account_phone: '전화번호',
  account_two_factor: '2단계 인증',
  account_save_changes: '변경사항 저장',
  account_cancel: '취소',

  // Support
  support_btn_send: '답장 보내기',
  support_edit_message: '메시지 수정',
  support_delete_message: '메시지 삭제',
  support_delete_confirm: '이 메시지를 삭제하시겠습니까?',
  support_message_updated: '메시지가 성공적으로 수정되었습니다',
  support_message_deleted: '메시지가 성공적으로 삭제되었습니다',
  support_err_already_read: '이미 확인된 메시지는 수정할 수 없습니다.',
  support_faq: '자주 묻는 질문',
  support_contact_us: '문의하기',
  support_live_chat: '실시간 채팅',
  support_ticket_tracker: '티켓 추적',
  support_submit_ticket: '티켓 제출',

  // Auth
  auth_email: '이메일',
  auth_password: '비밀번호',
  auth_confirm_password: '비밀번호 확인',
  auth_forgot_password: '비밀번호를 잊으셨나요?',
  auth_remember_me: '로그인 상태 유지',
  auth_login_button: '로그인',
  auth_signup_button: '가입',
  auth_already_have_account: '이미 계정이 있으신가요?',
  auth_dont_have_account: '계정이 없으신가요?',
  auth_reset_password: '비밀번호 재설정',
  auth_verify_email: '이메일 확인',

  // Common
  common_loading: '로딩 중...',
  common_save: '저장',
  common_cancel: '취소',
  common_delete: '삭제',
  common_edit: '편집',
  common_view: '보기',
  common_search: '검색',
  common_filter: '필터',
  common_export: '내보내기',
  common_import: '가져오기',
  common_submit: '제출',
  common_close: '닫기',
  common_confirm: '확인',
  common_success: '성공',
  common_error: '오류',
  common_warning: '경고',

  // Homepage
  home_hero_title: '최고의 전자상거래 플랫폼에서 수수료 획득',
  home_hero_subtitle: 'Walmart, eBay, AliExpress에서 매일 수수료를 받는 수천 명의 사용자와 함께하세요',
  home_get_started: '지금 시작하기',
  home_learn_more: '자세히 알아보기',
  home_how_it_works: '작동 방식',
  home_features: '기능',
  home_commission_tiers: '수수료 등급',
  home_testimonials: '사용자 후기',
  home_faq: '자주 묻는 질문',
  home_cta_title: '수익을 시작할 준비가 되셨나요?',
  home_cta_subtitle: '오늘 커뮤니티에 가입하고 수수료를 받기 시작하세요',

  // Feature Section
  feature_1_title: '즉시 결제',
  feature_1_desc: '주문 완료 후 즉시 수익이 반영됩니다. 지연 없이 언제든지 출금할 수 있습니다.',
  feature_1_detail_1: '실시간 수수료 크레딧',
  feature_1_detail_2: '다양한 출금 옵션',
  feature_1_detail_3: '최소 한도 없음',
  feature_2_title: '안전한 플랫폼',
  feature_2_desc: '은행 수준의 암호화로 데이터와 수익을 보호합니다. 전 세계 수천 명의 사용자가 신뢰합니다.',
  feature_2_detail_1: 'SSL 암호화 활성화',
  feature_2_detail_2: '2단계 인증',
  feature_2_detail_3: '정기 보안 감사',
  feature_2_detail_4: '데이터 프라이버시 보장',
  feature_3_title: '유연한 시간',
  feature_3_desc: '원할 때 어디서나 일하세요. 고정된 일정 없이 본인의 속도에 맞춰 주문을 완료하세요.',
  feature_3_detail_1: '고정 근무 시간 없음',
  feature_3_detail_2: '어디서나 근무 가능',
  feature_3_detail_3: '본인의 속도 선택',
  feature_3_detail_4: '주말 이용 가능',
  feature_4_title: '점진적 수익',
  feature_4_desc: '더 많은 주문을 완료할수록 더 높은 수수료율을 잠금 해제하세요. 각 등급 업그레이드와 함께 수입을 늘리세요.',
  feature_4_detail_1: '등급별 수수료율',
  feature_4_detail_2: '자동 등급 업그레이드',
  feature_4_detail_3: '성과 보상',
  feature_5_title: '글로벌 플랫폼',
  feature_5_desc: '전 세계 어디서나 국제 브랜드와 협력하세요. 다중 통화 지원이 포함됩니다.',
  feature_5_detail_1: '전 세계 이용 가능',
  feature_5_detail_2: '다중 통화 지원',
  feature_5_detail_3: '로컬 결제 수단',
  feature_6_title: '24/7 지원',
  feature_6_desc: '전담 지원 팀이 항상 도와드릴 준비가 되어 있습니다. 실시간 채팅, 이메일 또는 전화를 통해 지원을 받으세요.',
  feature_6_detail_1: '실시간 채팅 가능',
  feature_6_detail_2: '24/7 이메일 지원',
  feature_6_detail_3: '전화 지원',
  feature_6_detail_4: '종합 FAQ',
  feature_7_title: '추천 프로그램',
  feature_7_desc: '친구를 초대하여 추가 수입을 올리세요. 추천인의 수익에서 평생 수수료를 받으세요.',
  feature_7_detail_1: '평생 추천 수익',
  feature_7_detail_2: '무제한 추천',
  feature_7_detail_3: '쉬운 공유 도구',
  feature_7_detail_4: '보너스 인센티브',
  feature_8_title: '다중 통화 지원',
  feature_8_desc: '주요 통화 및 결제 수단을 지원합니다. 본인에게 가장 적합한 것을 선택하세요.',
  feature_8_detail_1: 'USD, EUR, GBP 지원',
  feature_8_detail_2: '은행 송금 가능',
  feature_8_detail_3: '전자 지갑 통합',
  feature_8_detail_4: '암호화폐 옵션 출시 예정',
  feature_9_title: '즉시 알림',
  feature_9_desc: '새로운 주문, 수익 및 계정 활동에 대한 실시간 알림으로 최신 정보를 확인하세요.',
  feature_9_detail_1: '푸시 알림',
  feature_9_detail_2: '이메일 알림',
  feature_9_detail_3: 'SMS 업데이트',
  feature_9_detail_4: '앱 내 메시지',

  // Footer
  footer_about: '회사 소개',
  footer_terms: '서비스 약관',
  footer_privacy: '개인정보 보호정책',
  footer_contact: '연락처',
  footer_copyright: '모든 권리 보유',

  // Redesigned Footer
  footer_stay_loop_title: '최신 정보 받기',
  footer_stay_loop_desc: '최신 업데이트, 팁 및 독점 혜택을 받은 편지함으로 직접 받으세요.',
  footer_subscribe: '구독하기',
  footer_subscribe_placeholder: '이메일 주소를 입력하세요',
  footer_trusted_secure: '신뢰 및 보안:',
  footer_ssl_secured: 'SSL 보안',
  footer_ssl_secured_desc: '256비트 SSL',
  footer_aes_encryption: 'AES-256 암호화',
  footer_aes_encryption_desc: '은행 수준',
  footer_kyc_compliant: 'KYC 준수',
  footer_kyc_compliant_desc: '확인됨',
  footer_gdpr_compliant: 'GDPR 준수',
  footer_gdpr_compliant_desc: '데이터 보호됨',
  footer_iso_certified: 'ISO 27001',
  footer_iso_certified_desc: '인증됨',
  footer_platform: '플랫폼',
  footer_support: '지원',
  footer_legal: '법적 정보',
  footer_help_center: '고객 센터',
  footer_contact_us: '문의하기',
  footer_payments_label: '결제 방법:',
  home_live_activity_title: '라이브 플랫폼 활동',
  home_recent_activity_title: '최근 활동',
  home_total_commissions_paid: '총 지급 수수료',
  home_active_users_online: '온라인 활성 사용자',
  home_tasks_completed_today: '오늘 완료된 작업',
  account_security_tips_title: '보안 권장 사항',
  account_security_tips_desc: '다음의 간단한 모범 사례를 따라 계정 보호를 강화하세요.',
  tip_password_title: '강력한 비밀번호',
  tip_password_desc: '계정의 안전을 위해 문자, 숫자 및 기호의 조합을 사용하세요.',
  tip_two_factor_title: '본인 확인',
  tip_two_factor_desc: '중요한 보안 알림을 받으려면 연락처 정보를 최신 상태로 유지하세요.',
  tip_logout_title: '정기적인 로그아웃',
  tip_logout_desc: '공용 또는 공용 컴퓨터를 사용할 때는 항상 계정에서 로그아웃하십시오.',
  tip_sharing_title: '액세스 공유 금지',
  tip_sharing_desc: '당사의 지원팀은 귀하의 비밀번호를 묻지 않습니다. 귀하의 자격 증명을 다른 사람과 공유하지 마십시오.',

  // 주문 요청
  order_requests_title: '주문 요청',
  order_requests_desc: '새로운 작업이나 맞춤 주문에 대한 요청을 제출하십시오. 관리자가 요청에 따라 작업을 검토하고 할당합니다.',
  order_requests_new_btn: '새 주문 요청',
  order_requests_table_id: '요청 ID',
  order_requests_table_data: '요청 세부 정보',
  order_requests_table_status: '상태',
  order_requests_table_date: '제출일',
  order_requests_table_actions: '작업',
  order_requests_cancel: '취소',
  order_requests_cancel_confirm: '이 주문 요청을 취소하시겠습니까?',
  order_requests_cancel_success: '주문 요청이 성공적으로 취소되었습니다.',
  order_requests_create_success: '주문 요청이 성공적으로 제출되었습니다.',
  order_requests_modal_title: '새 주문 요청 제출',
  order_requests_modal_desc: '요청하고자 하는 주문에 대한 자세한 정보를 제공해 주십시오.',
  order_requests_field_data: '주문 요청 데이터',
  order_requests_field_placeholder: '예: 프리미엄 패키지에 대한 맞춤 주문을 요청하고 싶습니다.',
  order_requests_btn_submit: '요청 제출',
  order_requests_btn_submitting: '제출 중...',
  order_requests_empty: '주문 요청을 찾을 수 없습니다.',
  order_requests_status_pending: '대기 중',
  order_requests_status_approved: '승인됨',
  order_requests_status_rejected: '거절됨',
  order_requests_status_cancelled: '취소됨',
  order_requests_terms_title: '구속력 있는 주문 약관',
  order_requests_term_1: '새 주문은 승인 후 24-48시간 이내에 할당됩니다.',
  order_requests_term_2: '출고된 주문은 취소, 일시 중지 또는 수정할 수 없습니다.',
  order_requests_term_3: '할당된 모든 주문은 인출 전에 완료되어야 합니다.',
  order_requests_term_4: '주문 완료 실패는 계정 상태에 영향을 줄 수 있습니다.',
  order_requests_term_5: '이 요청은 최종적이며 제출 후 고칠 수 없습니다.',
  order_requests_policy_title: '취소 불가능 정책',
  order_requests_policy_desc: '이 요청을 제출함으로써 귀하는 새 주문 배치가 철회 불가능함을 인정합니다. 당사 시스템에 의해 확인된 후에는 어떠한 경우에도 취소, 수정 또는 환불이 허용되지 않습니다.',
  order_requests_accept_terms: '본인은 위의 약관을 읽고 완전히 이해했습니다. 제출된 주문 요청은 취소하거나 수정할 수 없음을 인정하며, 할당된 모든 주문을 완료하는 데 동의합니다.',

  // Orders Page (New Sections)
  orders_withdrawal_policy: '출금 정책',
  orders_unlock_req: '잠금 해제 요건',
  orders_unlock_desc: '출금 기능을 영구적으로 잠금 해제하려면 첫 번째 {{count}}개 주문 배치를 완료하십시오. 이 일회성 요건은 플랫폼의 무결성을 보장하고 남용을 방지하기 위한 것입니다.',
  orders_daily_limits: '일일 주문 한도',
  orders_daily_limit_1: '배치당 {{count}}개 주문 — 다음 배치를 요청하기 전에 모두 완료해야 합니다',
  orders_daily_limit_2: '일일 최대 {{count}}개 배치 (일일 총 {{total}}개 주문)',
  orders_comm_rates: '수수료율',
  orders_comm_rates_desc: '수수료율은 플랫폼과 현재 지갑 잔액에 의해 결정됩니다:',
  orders_payout_timeline: '지급 일정',
  orders_payout_desc: '출금은 24-48시간 이내에 처리됩니다. 은행 송금은 영업일 기준 3-5일이 소요될 수 있습니다. 암호화폐 출금은 즉시 처리됩니다.',
  orders_processing_fee: '거래 비용을 충당하기 위해 모든 출금에 {{fee}}%의 처리 수수료가 적용됩니다.',
  orders_tips_title: '성공을 위한 팁',
  orders_tips_1: '매일 주문을 완료하여 리듬을 만들고 수익을 극대화하십시오',
  orders_tips_2: '적절한 완료를 위해 처리 중에는 페이지에 머물러 주십시오',
  orders_tips_3: '정기적으로 지갑을 체크하여 수수료 증가를 확인하십시오',
  orders_tips_4: '친구를 추천하여 그들의 주문에서 보너스 수수료를 받으십시오',
  orders_tips_5: '문제가 발생하면 즉시 고객 지원팀에 문의하십시오.',
  orders_batch_approx: '배치당 {{count}}개 주문 × 평균 ${{avg}} = 배치당 약 ${{total}}',

  // Settings
  settings_page_title: '설정',
  settings_page_desc: '보안, 개인 정보 및 기본 설정 관리',
  settings_kyc_label: 'KYC 인증',
  settings_kyc_desc: '본인 확인',
  settings_security_label: '보안',
  settings_security_desc: '비밀번호 관리',
  settings_language_label: '언어',
  settings_language_desc: '지역 설정',
  // 입금 모달
  deposit_modal_title_method: "결제 방법 선택",
  deposit_modal_title_gateway: "암호화폐 지갑 선택",
  deposit_modal_title_plan: "입금 플랜 선택",
  deposit_modal_title_details: "입금 상세 정보",
  deposit_modal_step_method: "방법",
  deposit_modal_step_gateway: "지갑",
  deposit_modal_step_plan: "플랜",
  deposit_modal_step_details: "상세",
  deposit_modal_credit_card: "신용카드 / 체크카드",
  deposit_modal_bank_transfer: "은행 송금",
  deposit_modal_ewallet: "전자 지갑",
  deposit_modal_digital_currency: "디지털 통화",
  deposit_modal_not_available: "현재 거주 지역에서 사용할 수 없습니다",
  deposit_modal_available_recommended: "사용 가능 — 권장",
  deposit_modal_back_to_method: "결제 방법으로 돌아가기",
  deposit_modal_back_to_gateway: "지갑 목록으로 돌아가기",
  deposit_modal_back_to_plan: "플랜으로 돌아가기",
  deposit_modal_digital_selected: "디지털 통화 선택됨",
  deposit_modal_digital_hint: "주소 및 지침을 받으려면 암호화폐 지갑을 선택하세요.",
  deposit_modal_loading_wallets: "지갑 로딩 중...",
  deposit_modal_no_wallets: "사용 가능한 암호화폐 지갑이 없습니다.",
  deposit_modal_loading_plans: "플랜 로딩 중...",
  deposit_modal_no_plans: "현재 사용 가능한 입금 플랜이 없습니다.",
  deposit_modal_duration: "기간",
  deposit_modal_amounts_profits: "금액 및 수익",
  deposit_modal_amount_label: "금액",
  deposit_modal_profit_label: "수익",
  deposit_modal_benefits: "혜택",
  deposit_modal_continue: "계속하기",
  deposit_modal_transfer_details: "{{name}} 송금 상세 정보",
  deposit_modal_deposit_amount: "입금 금액",
  deposit_modal_amount_fixed: "선택한 플랜에 의해 금액이 고정되었습니다",
  deposit_modal_txn_id: "트랜잭션 ID",
  deposit_modal_txn_optional: "(선택 사항)",
  deposit_modal_txn_placeholder: "예: 0x1a2b3c4d...",
  deposit_modal_screenshot: "스크린샷",
  deposit_modal_upload_proof: "결제 증명 업로드",
  deposit_modal_upload_hint: "PNG, JPG, JPEG — 최대 5MB",
  deposit_modal_comments: "코멘트",
  deposit_modal_comments_placeholder: "추가 정보가 필요하신가요?",
  deposit_modal_notice: "제출 후 저희 팀이 결제 내용을 확인하고 5~30분 이내에 계정에 입금 처리해 드립니다.",
  deposit_modal_confirm: "입금 확인",
  deposit_modal_submitting: "제출 중...",
  deposit_modal_err_fields: "모든 필수 필드를 채워주세요",
  deposit_modal_err_submit: "제출 중 오류가 발생했습니다",
  deposit_modal_success: "입금 요청이 성공적으로 완료되었습니다!",
  deposit_modal_err_plans: "입금 플랜을 불러오지 못했습니다",
  deposit_modal_err_wallets: "결제 방법을 불러오지 못했습니다",
  deposit_modal_new_to_crypto: "New to crypto? Learn how to buy digital currency",
  deposit_modal_crypto_label: "암호화폐",
  orders_insufficient_balance: "Insufficient Balance",
  orders_balance_gap_msg1: "Your current balance is not enough to complete this order.",
  orders_balance_gap_msg2_start: "Please add",
  orders_balance_gap_msg2_end: "to proceed and unlock your commission.",
  orders_btn_add_funds: "Add Funds",
};
